import ApiService from "@/services/ApiService";
import Cache from "@/services/Cache";

export interface StoppedClockAction
{
    /** Show the Request (ClockDone) modal - only when the current user owns the linked Request ticket. */
    showDoneModal: boolean;
    /** Job (Request) id to open when showDoneModal is false, if there is one. */
    jobId: number | null;
}

/**
 * Decides the follow-up UI after a clock stop:
 * - ClockDoneModal only when the stop is linked to a Request ticket
 *   (WorkOrder Title='Request') AND the current user is the ticket's Owner.
 * - Otherwise the parent Job modal, matching non-request clock stops.
 */
export const resolveStoppedClockAction = async (data: any): Promise<StoppedClockAction> =>
{
    const jobId = data?.task?.RequestId || data?.request?.Id || null;

    // Resolve the linked request ticket. InitialRequest is the canonical
    // request-ticket column; WorkOrderId is reserved for invoices.
    let workOrder = data?.workOrder || data?.task?.InitialRequestWorkOrder || null;
    const ticketId = workOrder?.Id
        || data?.task?.InitialRequest
        || (data?.isRequestClock ? data?.clock?.RequestId : null)
        || null;

    if (ticketId && !workOrder?.Id)
    {
        try
        {
            workOrder = await ApiService.loadWorkOrder(ticketId);
        }
        catch (e)
        {
            console.warn("resolveStoppedClockAction: failed to load request ticket", e);
        }
    }

    // session.UserId is the logged-in Technician Id - the same id space as
    // WorkOrder.Owner.
    const session = await Cache.get("radar_user");
    const isOwner = workOrder?.Title === "Request"
        && !!session?.UserId
        && Number(workOrder?.Owner) === Number(session.UserId);

    return {
        showDoneModal: !!isOwner,
        jobId: jobId ? Number(jobId) : null,
    };
};
